import React from "react";
import PropTypes from "prop-types";
import Link, { navigateTo } from "gatsby-link";
import styles from "./index.module.css";

import { ShareLinkedIn, ShareTwitter } from "../Share";
import CloseButton from "../CloseButton";
import ActionButton from "../ActionButton";
import SaveIcon from "../SaveIcon";
import FilterIcon from "../FilterIcon";
import SharingConfig from "../../utils/sharingConfig";

const onLinkClick = (e, path, navClose) => {
  e.preventDefault();
  navClose();
  setTimeout(() => navigateTo(path), 300);
};

const NavDrawer = ({
  onNavClose,
  chapters,
  savedArticleCount,
  onDownloadClick
}) => {
  const savedCountLabel = savedArticleCount ? `${savedArticleCount}` : "0";
  const shareUrl = SharingConfig.defaultShareUrl;
  const linkedInShareText = SharingConfig.defaultShareTextLinkedin;
  const shareText = SharingConfig.defaultShareTextTwitter;
  const twitterShareText = `${shareText} ${shareUrl}`;
  return (
    <nav className={styles.root}>
      <div className={styles.inner}>
        <div className={styles.header}>
          <Link to="/" className={styles.title} onClick={onNavClose}>
            The State of European Tech 2017
          </Link>
          <div className={styles.button}>
            <CloseButton onClick={onNavClose} />
          </div>
        </div>
        <ul className={styles.navList}>
          {chapters.map(chapter => (
            <li key={chapter.titleNumber} className={styles.navItem}>
              <Link
                className={styles.navLink}
                activeClassName={styles.navLinkActive}
                to={chapter.path}
                onClick={e => {
                  onLinkClick(e, chapter.path, onNavClose);
                }}
              >
                <span className={styles.navLinkBullet}>
                  {chapter.titleNumber}
                </span>
                {chapter.title}
              </Link>
            </li>
          ))}
          <li key="savedArticles" className={styles.navItemSpecial}>
            <Link
              className={styles.navLink}
              activeClassName={styles.navLinkActive}
              to="/saved/"
              onClick={onNavClose}
            >
              <span className={styles.navLinkBullet}>
                <SaveIcon stroke="currentColor" fill="transparent" />
              </span>
              Saved ({savedCountLabel})
            </Link>
          </li>
          <li key="filterArticles" className={styles.navItemSpecial}>
            <Link
              className={styles.navLink}
              activeClassName={styles.navLinkActive}
              to="/filter/"
              onClick={onNavClose}
            >
              <span className={styles.navLinkBullet}>
                <FilterIcon stroke="currentColor" fill="currentColor" />
              </span>
              Filter report
            </Link>
          </li>
        </ul>
        <div className={styles.actions}>
          <div>
            <ActionButton
              onClick={onDownloadClick}
              label={"Download Report"}
              large={true}
            />
          </div>
          <div className={styles.actionShare}>
            <div className={styles.action}>
              <ShareLinkedIn url={shareUrl} title={linkedInShareText} />
            </div>
            <div className={styles.action}>
              <ShareTwitter text={twitterShareText} />
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

NavDrawer.propTypes = {
  onNavClose: PropTypes.func.isRequired,
  onDownloadClick: PropTypes.func,
  savedArticleCount: PropTypes.number,
  chapters: PropTypes.arrayOf(
    PropTypes.shape({
      titleNumber: PropTypes.string,
      path: PropTypes.string
    })
  )
};

export default NavDrawer;



// WEBPACK FOOTER //
// ./src/components/NavDrawer/index.js